/* Pave the Way theme: small, dependency-free interactions */
(function () {
  var header = document.querySelector('[data-header]');
  var menuBtn = document.querySelector('[data-menu-btn]');

  function closeSubs(except) {
    document.querySelectorAll('.nav__item.is-open').forEach(function (li) {
      if (li !== except) {
        li.classList.remove('is-open');
        var t = li.querySelector('[data-sub-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
  }

  if (menuBtn && header) {
    menuBtn.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-sub-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var li = toggle.closest('.nav__item');
      var open = !li.classList.contains('is-open');
      closeSubs(li);
      li.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav__item')) closeSubs();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeSubs();
    if (header && header.classList.contains('is-open')) {
      header.classList.remove('is-open');
      if (menuBtn) { menuBtn.setAttribute('aria-expanded', 'false'); menuBtn.focus(); }
    }
  });

  document.querySelectorAll('[data-compare]').forEach(function (box) {
    var range = box.querySelector('[data-compare-range]');
    if (!range) return;
    var update = function () { box.style.setProperty('--pos', range.value + '%'); };
    range.addEventListener('input', update);
    update();
  });
})();

/* Portfolio filters */
(function () {
  document.querySelectorAll('[data-portfolio]').forEach(function (root) {
    var state = { service: '', area: '' };
    var items = [].slice.call(root.querySelectorAll('[data-tags]'));
    var count = root.querySelector('[data-portfolio-count]');
    var empty = root.querySelector('[data-portfolio-empty]');

    function apply() {
      var shown = 0;
      items.forEach(function (item) {
        var tags = item.getAttribute('data-tags');
        var ok = (!state.service || tags.indexOf('|' + state.service + '|') > -1) &&
                 (!state.area || tags.indexOf('|' + state.area + '|') > -1);
        item.hidden = !ok;
        if (ok) shown++;
      });
      if (count) count.textContent = 'Showing ' + shown + ' of ' + items.length + ' projects';
      if (empty) empty.hidden = shown !== 0;
    }

    root.querySelectorAll('[data-filter-group]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.getAttribute('data-filter-group');
        state[group] = btn.getAttribute('data-filter');
        root.querySelectorAll('[data-filter-group="' + group + '"]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      });
    });
    apply();
  });
})();

/* Popup offer */
(function () {
  var el = document.getElementById('site-popup');
  if (!el) return;
  var key = 'ptw_popup_dismissed';
  var freq = el.getAttribute('data-frequency');
  var delay = parseInt(el.getAttribute('data-delay'), 10) || 0;

  function periodMs() {
    if (freq === 'day') return 24 * 60 * 60 * 1000;
    if (freq === 'week') return 7 * 24 * 60 * 60 * 1000;
    return 0;
  }

  function shouldShow() {
    if (freq === 'always') return true;
    if (freq === 'session') return !sessionStorage.getItem(key);
    try {
      var last = parseInt(localStorage.getItem(key), 10);
      if (!last) return true;
      return Date.now() - last > periodMs();
    } catch (e) {
      return true;
    }
  }

  function markDismissed() {
    try {
      if (freq === 'session') {
        sessionStorage.setItem(key, '1');
      } else if (freq !== 'always') {
        localStorage.setItem(key, String(Date.now()));
      }
    } catch (e) {}
  }

  function open() {
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-open'); });
  }

  function close() {
    el.classList.remove('is-open');
    markDismissed();
    setTimeout(function () { el.hidden = true; }, 250);
  }

  if (shouldShow()) {
    setTimeout(open, delay);
  }

  el.querySelectorAll('[data-popup-close]').forEach(function (btn) {
    btn.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && el.classList.contains('is-open')) close();
  });
})();
